import React, { ReactNode, useState, useEffect } from "react";

interface Props {
  children: ReactNode;
}

const ErrorBoundary: React.FC<Props> = ({ children }) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const errorHandler = (event: ErrorEvent) => {
      console.error("ErrorBoundary caught an error:", event.error);
      setHasError(true);
    };

    window.addEventListener("error", errorHandler);
    return () => window.removeEventListener("error", errorHandler);
  }, []);

  if (hasError) {
    return <h2>Something went wrong. Please try again later.</h2>;
  }

  return <>{children}</>;
};

export default ErrorBoundary;
